export default "__VITE_ASSET__kaZ8iQ_d__"